__turbopack_context__.v({
  "close-button": "style-module-scss-module__jZtfoW__close-button",
  "component": "style-module-scss-module__jZtfoW__component",
});
